// Define the API endpoint you want to send the URL to
const apiEndpoint = 'https://sticklett.app01.leadpaka.de/api/endpoint';

// ---------------------------------------------------

const currentPageUrl = window.location.href;

function getFbcCookie() {
    var cookies = document.cookie.split(';');
    var fbcValue = null;

    cookies.forEach(function(cookie) {
        var parts = cookie.split('=');
        var key = parts[0].trim();
        var value = parts[1];

        if (key === '_fbc') {
            fbcValue = value;
        }
    });

    return fbcValue;
}

function getFbpCookie() {
    var cookies = document.cookie.split(';');
    var fbpValue = null;

    cookies.forEach(function(cookie) {
        var parts = cookie.split('=');
        var key = parts[0].trim();
        var value = parts[1];

        if (key === '_fbp') {
            fbpValue = value;
        }
    });

    return fbpValue;
}

function getCartCookie() {
    var cookies = document.cookie.split(';');
    var cartValue = null;

    cookies.forEach(function(cookie) {
        var parts = cookie.split('=');
        var key = parts[0].trim();
        var value = parts[1];

        if (key === 'cart') {
            cartValue = value;
        }
    });

    return cartValue;
}

function generateRandomString(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
}

let fingerprint;
if (localStorage.getItem('fingerprint') === null) {
    fingerprint = generateRandomString(40);
    localStorage.setItem('fingerprint', fingerprint);
} else {
    fingerprint = localStorage.getItem('fingerprint');
}

var fbcCookie = getFbcCookie();
var fbpCookie = getFbpCookie();

const data = {
    url: currentPageUrl,
    fbp: fbpCookie,
    fbc: fbcCookie,
    fingerP: fingerprint,
    cart: getCartCookie(),
};


// const checkoutButton = document.getElementById('checkout_slideout1');

// if (!checkoutButton) {
//     console.info('Checkout button not found');
// } else {

//     checkoutButton.addEventListener('click', function(event) {
//         const data = {
//             url: currentPageUrl,
//             fbp: fbpCookie,
//             fbc: fbcCookie,
//             fingerP: fingerprint,
//             action: "ci1",
//             cart: getCartCookie(),
//         };
//         fetch(apiEndpoint, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify(data),
//             keepalive: true
//         })
//             .then(response => response.json())
//             .then(data => {
//                 console.log('Success:', data);

//             })
//             .catch((error) => {
//                 console.error('Error:', error);
//             });

//     });
// }

document.addEventListener("click", function (e) {
  const btn = e.target.closest("#checkout_slideout1");
  if (!btn) return; 

        const data = {
            url: currentPageUrl,
            fbp: fbpCookie,
            fbc: fbcCookie,
            fingerP: fingerprint,
            action: "ci1",
            cart: getCartCookie(),
        };
        fetch(apiEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
            keepalive: true
        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);

            })
            .catch((error) => {
                console.error('Error:', error);
            });
  }

)
document.addEventListener("click", function (e) {
  const btn = e.target.closest("#checkout_slideout");
  if (!btn) return; 

        const data = {
            url: currentPageUrl,
            fbp: fbpCookie,
            fbc: fbcCookie,
            fingerP: fingerprint,
            action: "ci1",
            cart: getCartCookie(),
        };
        fetch(apiEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
            keepalive: true
        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);

            })
            .catch((error) => {
                console.error('Error:', error);
            });

  }

)


const checkoutButton2 = document.querySelector('[data-testid="AddToCart"]');;

if (!checkoutButton2) {
    console.info('Checkout product button not found');
} else {
    console.info('Checkout product found');
    checkoutButton2.addEventListener('click', function(event) {
        const data = {
            url: currentPageUrl,
            fbp: fbpCookie,
            fbc: fbcCookie,
            fingerP: fingerprint,
            action: "ci2",
            cart: getCartCookie(),
        };
        fetch(apiEndpoint, {
            method: 'POST', // or 'PUT'
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
            keepalive: true
        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);
            })
            .catch((error) => {
                console.error('Error:', error);
            });

    });
}

const checkoutButton3 = document.getElementById('checkoutButton3');

if (!checkoutButton3) {
    console.info('CheckoutButton3 button not found');
} else {

    console.info('CheckoutButton3 found');

    checkoutButton3.addEventListener('click', function(event) {
        const data = {
            url: currentPageUrl,
            fbp: fbpCookie,
            fbc: fbcCookie,
            fingerP: fingerprint,
            action: "ci3",
            cart: getCartCookie(),
        };
        fetch(apiEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
            keepalive: true
        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);
            })
            .catch((error) => {
                console.error('Error:', error);
            });

    });
}

// const addToCartButton = document.getElementById('ATC_Produkt');

// if (!addToCartButton) {
//     console.info('Checkout button not found');
// } else {

//     addToCartButton.addEventListener('click', function(event) {
//         const data = {
//             url: currentPageUrl,
//             fbp: fbpCookie,
//             fbc: fbcCookie,
//             fingerP: fingerprint,
//             action: "addToCard",
//             cart: getCartCookie(),
//         };
//         fetch(apiEndpoint, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify(data),
//             keepalive: true
//         })
//             .then(response => response.json())
//             .then(data => {
//                 console.log('Success:', data);

//             })
//             .catch((error) => {
//                 console.error('Error:', error);
//             });

//     });
// }

fetch(apiEndpoint, {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
})
    .then(response => response.json())
    .then(data => {
        console.log('Success:', data);

    })
    .catch((error) => {
        console.error('Error:', error);
    });

document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(event) {

    if (event.target && event.target.matches('[data-testid="PayPalInContext-button"]')) {
alert('')
        const data = {
            url: currentPageUrl,
            fbp: fbpCookie,
            fbc: fbcCookie,
            fingerP: fingerprint,
            action: "paypal express",
            cart: getCartCookie(),
        };
        fetch(apiEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
            keepalive: true
        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);

            })
            .catch((error) => {
                console.error('Error:', error);
            });

    }
    });

});

// const addToCartButton2 = document.getElementById('option_ATC');

// if (!addToCartButton2) {
//     console.info('Option_ATC button not found');
// } else {

   
//     addToCartButton2.addEventListener('click', function(event) {
  
//         const data = {
//             url: currentPageUrl,
//             fbp: fbpCookie,
//             fbc: fbcCookie,
//             fingerP: fingerprint,
//             action: "addToCard",
//             cart: getCartCookie(),
//         };
//         fetch(apiEndpoint, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify(data),
//             keepalive: true
//         })
//             .then(response => response.json())
//             .then(data => {
//                 console.log('Success:', data);

//             })
//             .catch((error) => {
//                 console.error('Error:', error);
//             });

//     });
// }

// document.addEventListener('DOMContentLoaded', () => {
//     const addToCartButton2 = document.getElementById('option_ATC');

//     if (!addToCartButton2) {
//         console.info('Option_ATC button not found');
//     } else if (!addToCartButton2.dataset.listenerAttached) {
//         addToCartButton2.dataset.listenerAttached = "true"; // Prevent multiple attachments

//         addToCartButton2.addEventListener('click', function(event) {
//             const data = {
//                 url: currentPageUrl,
//                 fbp: fbpCookie,
//                 fbc: fbcCookie,
//                 fingerP: fingerprint,
//                 action: "addToCard",
//                 cart: getCartCookie(),
//             };

//             fetch(apiEndpoint, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify(data),
//                 keepalive: true
//             })
//                 .then(response => response.json())
//                 .then(data => {
//                     console.log('Success:', data);
//                 })
//                 .catch((error) => {
//                     console.error('Error:', error);
//                 });
//         });
//     }
// });

document.addEventListener('click', function (e) {
  if (e.target.closest('[data-submit-button]')) {


    const data = {
      url: currentPageUrl,
      fbp: fbpCookie,
      fbc: fbcCookie,
      fingerP: fingerprint,
      action: "addToCard",
      cart: getCartCookie(),
    };

    fetch(apiEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      keepalive: true
    })
      .then(r => r.json())
      .then(res => console.log('Success:', res))
      .catch(err => console.error('Error:', err));
  }
});

document.addEventListener("click", function (e) {
  const btn = e.target.closest(".option-cus.showoption");
  if (!btn) return; 

      const data = {
      url: currentPageUrl,
      fbp: fbpCookie,
      fbc: fbcCookie,
      fingerP: fingerprint,
      action: "addToCard",
      cart: getCartCookie(),
    };

    fetch(apiEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      keepalive: true
    })
      .then(r => r.json())
      .then(res => console.log('Success:', res))
      .catch(err => console.error('Error:', err));
  }

)



// fetch(apiEndpoint, {
//     method: 'POST',
//     headers: {
//         'Content-Type': 'application/json',
//     },
//     body: JSON.stringify(data),
// })
//     .then(response => response.json())
//     .then(data => {
//         console.log('Success:', data);

//     })
//     .catch((error) => {
//         console.error('Error:', error);
//     });

document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(event) {

    if (event.target && event.target.matches('[data-testid="PayPalInContext-button"]')) {
alert('')
        const data = {
            url: currentPageUrl,
            fbp: fbpCookie,
            fbc: fbcCookie,
            fingerP: fingerprint,
            action: "paypal express",
            cart: getCartCookie(),
        };
        fetch(apiEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
            keepalive: true
        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);

            })
            .catch((error) => {
                console.error('Error:', error);
            });

    }
    });

});

document.addEventListener("click", function (e) {
  const btn = e.target.closest("#upsell_ATC");
  if (!btn) return; 



  const data = {
    url: currentPageUrl,
    fbp: fbpCookie,
    fbc: fbcCookie,
    fingerP: fingerprint,
    action: "addToCard",
    cart: getCartCookie(),
  };

  fetch(apiEndpoint, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
    keepalive: true,
  })
    .then((r) => r.json())
    .then((res) => console.log("Success:", res))
    .catch((err) => console.error("Error:", err));
});


// fetch(apiEndpoint, {
//     method: 'POST',
//     headers: {
//         'Content-Type': 'application/json',
//     },
//     body: JSON.stringify(data),
// })
//     .then(response => response.json())
//     .then(data => {
//         console.log('Success:', data);

//     })
//     .catch((error) => {
//         console.error('Error:', error);
//     });

document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(event) {

    if (event.target && event.target.matches('[data-testid="PayPalInContext-button"]')) {
alert('')
        const data = {
            url: currentPageUrl,
            fbp: fbpCookie,
            fbc: fbcCookie,
            fingerP: fingerprint,
            action: "paypal express",
            cart: getCartCookie(),
        };
        fetch(apiEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
            keepalive: true
        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);

            })
            .catch((error) => {
                console.error('Error:', error);
            });

    }
    });

});

var liElement = document.querySelector('li.XLcXEW3RnM9fyU7k7fvC');

if(liElement){
    liElement.addEventListener('click', function() {
        console.log('lE clicked');
    });
}

function handleCheckoutButton(checkoutButton) {
    console.log("hCB done");
    checkoutButton.addEventListener('click', function(event) {
        const data = {
            url: currentPageUrl,
            fbp: fbpCookie,
            fbc: fbcCookie,
            fingerP: fingerprint,
            action: "ci-product-page",
            cart: getCartCookie(),
        };
        fetch(apiEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
            keepalive: true
        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);

            })
            .catch((error) => {
                console.error('Error:', error);
            });


    });
}

function handleCheckoutButton2(checkoutButton) {
    console.log("hCB2 done");
    checkoutButton.addEventListener('click', function(event) {
        const data = {
            url: currentPageUrl,
            fbp: fbpCookie,
            fbc: fbcCookie,
            fingerP: fingerprint,
            action: "ci-product-page",
            cart: getCartCookie(),
        };
        fetch(apiEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
            keepalive: true
        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);

            })
            .catch((error) => {
                console.error('Error:', error);
            });


    });
}

const targetNode = document.body;

const config = { childList: true, subtree: true };

const callback = function(mutationsList, observer) {
    for(const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            const checkoutButton = document.querySelector('[data-testid="upstream-button"]');
            if (checkoutButton !== null) {
                handleCheckoutButton(checkoutButton);
                observer.disconnect();
                break;
            }
        }
    }
};

const observer = new MutationObserver(callback);
observer.observe(targetNode, config);

const zielElement = document.body;
const konfiguration = { childList: true, subtree: true };

const beobachtungsCallback = function(mutationsListe, beobachter) {
    for(const mutation of mutationsListe) {
        if (mutation.type === 'childList') {
            const checkoutButtons = document.querySelectorAll('[data-testid="ShopifyPay-button"]');
            checkoutButtons.forEach(checkoutButton => {
                checkoutButton.removeEventListener('click', handleCheckoutButtonClick);
                checkoutButton.addEventListener('click', handleCheckoutButtonClick);
            });
        }
    }
};

function handleCheckoutButtonClick(event) {
    handleCheckoutButton2(event.target);
}

const beobachter = new MutationObserver(beobachtungsCallback);
beobachter.observe(document.body, { childList: true, subtree: true });
